export const getFeatureFlag = (
  feature: string,
  optDefault = 'false'
): string => {
  const globalFeatures = window.FEATURES || {};
  const option = globalFeatures[feature];
  return typeof option === 'undefined' ? optDefault : option;
};

export const isEnabled = (feature: string, optDefault = 'false'): boolean => {
  return getFeatureFlag(feature, optDefault) === 'true';
};

// Our features
export const isAuth0AuthEnabled = () => isEnabled('auth0Auth');
export const isAzureAuthEnabled = () => isEnabled('azureAuth');
export const isGoogleAuthEnabled = () => isEnabled('googleAuth');
export const isOpenIDAuthEnabled = () => isEnabled('openidAuth');
export const isPingAuthEnabled = () => isEnabled('pingAuth');
export const isOktaAuthEnabled = () => isEnabled('oktaAuth');
export const isDuoAuthEnabled = () => isEnabled('duoAuth');
export const isSharedUserAuthEnabled = () => isEnabled('sharedUserAuth');
export const isKerberosAuthEnabled = () => isEnabled('kerberosAuth');
export const isPortalEnabled = () => isEnabled('portal');
export const isDataMarketplaceEnabled = () => isEnabled('dataMarketplace');
export const isHomeFooterLinksEnabled = () => isEnabled('homeFooterLinks');
export const isCopyConnectionTokenButtonEnabled = () =>
  isEnabled('copyConnectionTokenButtonEnabled', 'true');
